import * as THREE from 'three'
import {DefectControlCommand} from '@/components/Web3dModels/commands/DefectControlCommand.js'
import {
  ThreeExt, CARD1Web
} from '../CoordUtils.js';

export class BadDrawer{
    constructor(pos,info,sceneManager){
        this.pos=pos;
        this.info=info;
        this.sceneManager=sceneManager;
        this.roadStakes = this.sceneManager.geometryManager.getMainRoad().roadModel.model.roadStake;
        // console.log('roadStakes',this.roadStakes)
    }
    draw(){
       var helper = new CARD1Web.CoordUtils.Helper();
       var stakeObj=helper.getPtStake(this.pos,this.roadStakes);
        let startStake=stakeObj.prevStake;
        let endStake=stakeObj.nextStake;
        let lonCha=this.pos.z-this.sceneManager.CoordOffset.lon;
        let proportion=(lonCha-startStake.a3.z)/(endStake.a3.z-startStake.a3.z);
        let yCha=endStake.a3.y-startStake.a3.y;
        let targetY=startStake.a3.y+yCha*proportion;
        let target=new THREE.Vector3(this.pos.x-this.sceneManager.CoordOffset.lat,targetY,this.pos.z-this.sceneManager.CoordOffset.lon);
        let oindex=this.getBadIndex(this.info);
        var command = new DefectControlCommand(2, null, oindex,this.info);
        command.exec(this.sceneManager.webView);
        var mouseAction={
        	mouse:0,
        	model:this.sceneManager.currentMouseMovementAction.model,
        }  
        
        var pt1 = startStake.a1;
        var pt2 = endStake.a1;
        var pt3 = endStake.a2;

        var footPoint = this.getFootPoint(target, pt1, pt2);
        
        // let oTarget=new THREE.Vector3();
        mouseAction.model.position.copy(target);
        mouseAction.model.position.y += 0.05;
        // console.log('target',target);
        // console.log('footPoint',footPoint)
        var distance = target.distanceTo(footPoint);
        // 计算该向量到所传入的v间的距离。
        var roadWidth = pt2.distanceTo(pt3);
        var lookAtPt = new THREE.Vector3();
        // 将此向量设置为在v1和v2之间进行线性插值的向量， 其中alpha为两个向量之间连线的距离长度。 —— alpha = 0 时表示的是v1，alpha = 1 时表示的是v2
        lookAtPt.lerpVectors(pt2, pt3, distance / roadWidth);
        // console.log('lookAtPt',pt2);
        // console.log('lookAtPt',pt3);
        // console.log('lookAtPt',distance);
        // console.log('lookAtPt',roadWidth);
        mouseAction.model.loader.setStake(startStake, endStake, lookAtPt); //部分控件需要根据当前桩号设置方向
        this.sceneManager.fixModelAtPos(target);
    }
    getBadIndex(param){
        if(param.badType==1&&param.lv==1){
            return 0
        }else if(param.badType==1&&param.lv==2){
            return 1
        }else if(param.badType==1&&param.lv==3){
            return 2
        }else if(param.badType==2&&param.lv==1){
            return 3
        }else if(param.badType==2&&param.lv==3){
            return 4
        }else if(param.badType==3&&param.lv==1){
            return 5
        }else if(param.badType==3&&param.lv==3){
            return 6
        }else if(param.badType==4&&param.lv==1){
            return 7
        }else if(param.badType==4&&param.lv==3){
            return 8
        }else if(param.badType==5&&param.lv==1){
            return 9
        }else if(param.badType==5&&param.lv==3){
            return 10
        }else if(param.badType==6&&param.lv==1){
            return 11
        }else if(param.badType==6&&param.lv==3){
            return 12
        }else if(param.badType==7&&param.lv==1){
            return 13
        }else if(param.badType==7&&param.lv==3){
            return 14
        }else if(param.badType==8&&param.lv==1){
            return 15
        }else if(param.badType==8&&param.lv==3){
            return 16
        }else if(param.badType==9&&param.lv==1){
            return 17
        }else if(param.badType==9&&param.lv==3){
            return 18
        }else if(param.badType==10){
            return 19
        }else if(param.badType==11){
            return 20
        }else if(param.badType==12){
            return 21
        }else if(param.badType==13){
            return 22
        }else if(param.badType==14){
            return 23
        }
     }
     getFootPoint(pt0, pt1, pt2){
        var k = -((pt1.x - pt0.x) * (pt2.x - pt1.x) + (pt1.y - pt0.y) * (pt2.y - pt1.y) 
        + (pt1.z - pt0.z) * (pt2.z - pt1.z)) / (Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2) + Math.pow(pt2.z - pt1.z, 2));
        
        var pt = new THREE.Vector3(k * (pt2.x - pt1.x) + pt1.x, k * (pt2.y - pt1.y) + pt1.y, k * (pt2.z - pt1.z) + pt1.z); 
        return pt;
    }
}


// WEBPACK FOOTER //
// ./src/plugins/drawings3D/modelDrawing/BadDrawer.js